<template>
  <div class="d-flex">
    <v-btn
      v-if="actions.length"
      class="mr-2"
      depressed
      color="primary"
      @click="makeAction"
    >
      Podejmij działanie
    </v-btn>

    <v-btn
      v-if="isEditable"
      class="mr-2"
      depressed
      color="primary"
      link
      :to="{ name: 'commercial-print-edit', params: { id: commercialPrint.id } }"
    >
      Edycja
    </v-btn>

    <v-btn
      v-if="deletePermitted"
      depressed
      color="primary"
      @click="$emit('delete', commercialPrint.id)"
    >
      Usuń
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  props: {
    commercialPrint: {
      type: Object,
      required: true,
    },
    actions: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['checkUserPermissions']),
    deletePermitted() {
      const availability = ['admin_director', 'chief'];
      return this.checkUserPermissions(availability);
    },
    isEditable() {
      const { editable } = this.commercialPrint;
      return editable;
    },
  },

  methods: {
    ...mapActions('dialog', ['showDialog']),

    makeAction() {
      const { id, files } = this.commercialPrint;

      this.showDialog({
        header: 'Potwierdzenie działania',
        text: 'Masz do podjęcia działania w Akcydensie.',
        component: 'MakeAction',
        props: {
          id,
          files,
          actions: this.actions,
          width: 640,
          commercialPrint: true,
        },
      });
    },
  },
};
</script>
